import { Button, Grid, Typography } from '@mui/material';
import React, { JSX, useState } from 'react';
import ImageIcon from '@mui/icons-material/ImageOutlined'
import FileIcon from '@mui/icons-material/FilePresentOutlined';
import EXIF from "exif-js";
import { dataURLtoFile } from '@/stack-shared/utils/gen-utils';
import { RESOURCE_TYPE } from '@/stack-shared/constants/resource-constants';

interface IStandardUploadInputProps {
    //handleUpsertCall: (values: any, tabName: string, callback: () => void) => void;
    initialImage?: string
    handleSubmit: (data: any) => void
    infoText?: string
    onFileSelected?: (data: any) => void
    showUploadButton?: boolean
    showPreview?: boolean
    accept?: string
    multiple?: boolean
    uploadType?: string
    handleExif?: boolean
    isThumbnail?: boolean
    previewImageStyles?: any
  alignItems?: string
}

export const StandardUploadInput: React.FC<IStandardUploadInputProps> = (props): JSX.Element => {

    const hiddenFileInput = React.useRef<any>(null);

    const handleClick = (event: any) => {
        hiddenFileInput!.current!.click();
    };
    const [previewImage, setPreviewImage] = useState<string | null>(props.initialImage || null);

    const imageSrc = () => {
        if (previewImage) {
            return previewImage;
        }
        return props.initialImage || '/location_default.png';
    };

    const [selectedFiles, setSelectedFiles] = useState<FileList>();

    const handleNonExifFile = (curFile: any) => {
        return new Promise((resolve, reject) => {
            return resolve(curFile);
        })
    }

    const handleExifFile = async (curFile: any, exifData: any) => {
        return new Promise((resolve, reject) => {
            const orientation = EXIF.getTag(curFile, "Orientation");
            if (orientation && !isNaN(orientation) && orientation !== 1) {
                var img = document.createElement("img");
                var reader = new FileReader();
                reader.onload = function (e) {
                    var dimImage = new Image();

                    dimImage.onload = function () {
                        img.src = e.target!.result as string;
                        var canvas = document.createElement("canvas");
                        canvas.id = new Date().getTime().toString();
                        var ctx = canvas.getContext("2d");
                        canvas.width = dimImage.width;
                        canvas.height = dimImage.height;

                        ctx!.drawImage(
                            img,
                            0,
                            0,
                            dimImage.width,
                            dimImage.height,
                            0,
                            0,
                            dimImage.width,
                            dimImage.height
                        );
                        switch (orientation) {
                            case 2:
                                // horizontal flip
                                ctx!.translate(canvas.width, 0);
                                ctx!.scale(-1, 1);
                                break;
                            case 3:
                                // 180° rotate left
                                ctx!.translate(canvas.width, canvas.height);
                                ctx!.rotate(Math.PI);
                                break;
                            case 4:
                                // vertical flip
                                ctx!.translate(0, canvas.height);
                                ctx!.scale(1, -1);
                                break;
                            case 5:
                                // vertical flip + 90 rotate right
                                ctx!.rotate(0.5 * Math.PI);
                                ctx!.scale(1, -1);
                                break;
                            case 6:
                                // 90° rotate right
                                ctx!.rotate(0.5 * Math.PI);
                                ctx!.translate(0, -canvas.height);
                                break;
                            case 7:
                                // horizontal flip + 90 rotate right
                                ctx!.rotate(0.5 * Math.PI);
                                ctx!.translate(canvas.width, -canvas.height);
                                ctx!.scale(-1, 1);
                                break;
                            case 8:
                                // // 90° rotate left
                                ctx!.rotate(-0.5 * Math.PI);
                                ctx!.translate(-dimImage.width, 0);
                                break;
                        }

                        ctx!.restore();

                        const dataUrl = canvas.toDataURL("image/jpeg");

                        return resolve(dataURLtoFile(dataUrl, curFile.name || "test.jpeg"));
                    };

                    dimImage.src = e.target!.result as string;
                };
                reader.readAsDataURL(curFile);
            } else {
                return resolve(curFile);
            }
        });
    };


    const exifPromise = (curFile: any) => {
        return new Promise((resolve, reject) => {
            EXIF.getData(curFile, function () {
                var exifData = EXIF.pretty(curFile);
                if (exifData) {
                    return resolve(exifData)
                }
                else {
                    return resolve(null)
                }
            })
        })
    }

    const handleChangeFiles = async (e: any) => {
        const newFileArr = [] as any[];

        if (e.target.files) {
            for (let i = 0; i < e.target.files.length; i++) {
                const curFile = e.target.files[i];

                let newFile = curFile;
                if (props.handleExif) {
                    const exifData = await exifPromise(curFile);
                    newFile = exifData ? await handleExifFile(curFile, exifData) : await handleNonExifFile(curFile);
                }

                newFileArr.push(newFile);
            }
        }

        const fileArr = Array.from(newFileArr || []);
        if (fileArr.length > 0) {
            const newPreviewUrl = URL.createObjectURL(fileArr[0]); // Generate a temporary preview URL
            setPreviewImage(newPreviewUrl);
        }

        if (props.onFileSelected) {
            props.onFileSelected(fileArr);
        }
    };


    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: props.alignItems || 'center' }}>
                {props.showPreview && (
                    <div onClick={props.isThumbnail ? handleClick : () => {}} style={{
                        cursor: props.isThumbnail ? 'pointer' : 'default',
                    }}>
                        <img
                            style={{
                                width: 200,
                                height: 150,
                                backgroundColor: '#d1d1d1',
                                display: 'block',
                                objectFit: 'cover',
                                ...props.previewImageStyles
                            }}
                            src={imageSrc()}
                        />
                    </div>
                )}
                {props.uploadType === RESOURCE_TYPE.IMAGE && !props.isThumbnail && (
                    <div style={{ marginTop: 32, marginBottom: 8 }}>
                        <Button variant="outlined" startIcon={<ImageIcon />} onClick={handleClick}>
                            Select Image
                        </Button>
                    </div>
                )}
            </div>

            {props.uploadType === 'files' && (
                <Button style={{ marginBottom: 8 }} variant="contained" startIcon={<FileIcon />} onClick={handleClick}>
                    Select File
                </Button>
            )}

            <span style={{ fontSize: 12 }}>{props.infoText || ''}</span>

            <div className="flex flex-col items-center mt-2">
                <label
                    htmlFor="picture"
                    className="px-5 py-1 mt-6 bg-white border rounded-lg shadow cursor-pointer hover:bg-purple-600 hover:text-white"
                >
                    <input
                        ref={hiddenFileInput}
                        multiple={props.multiple || true}
                        type="file"
                        accept={props.accept || ".png, .jpg, .jpeg"}
                        id="picture"
                        name="picture"
                        className="hidden"
                        onChange={(e) => handleChangeFiles(e)}
                        style={{ display: 'none' }}
                    />
                </label>
            </div>

            {props.showUploadButton && (
                <Button variant={'outlined'} onClick={() => props.handleSubmit(selectedFiles)}>
                    Submit
                </Button>
            )}
        </>
    );
};
